import classNames from "lib/classNames";

export default function Divider({
  size = "md",
}: {
  size?: "lg" | "md" | "sm" | "xs";
}) {
  return (
    <hr
      className={classNames(
        "border-gray-100 dark:border-gray-700 border",
        size === "lg" ? "my-8" : "",
        size === "md" ? "my-4" : "",
        size === "sm" ? "my-2" : "",
        size === "xs" ? "my-1" : ""
      )}
    />
  );
}
